import { defineMessages } from "react-intl";

export const commonMessages = defineMessages({
  signOut: { id: "sideMenu.signOut", defaultMessage: "Sign out" },

  overviewTitle: { id: "overview.title", defaultMessage: "My account overview" },
  ordersTitle: { id: "orders.title", defaultMessage: "Orders" },
  settingsTitle: { id: "sideMenu.settings", defaultMessage: "My settings" },
  savedProjectsTitle: { id: "sideMenu.mySavedProjects", defaultMessage: "My saved projects" },
  widgetsTitle: { id: "sideMenu.widgets", defaultMessage: "My online photo books " },
  personalDetailsTitle: { id: "personalDetails.title", defaultMessage: "Change personal details" },
  changeEmailTitle: { id: "changeEmail.title", defaultMessage: "Change email address" },
  orderDetailsTitle: { id: "orders.details", defaultMessage: "Order details" }
});
